import React from 'react'
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    padding: '5px',
    fontSize:  window.innerWidth > 540 ? '0.85rem' : '10px',
    
  }),
  control: () => ({
    width: window.innerWidth > 540 ? '200px' : '180px',
    height: window.innerWidth > 540 ?'30px' : '20px',
    display: 'flex',
    border: '1px solid #b3b3b3',
    color: '#000',
    backgroundImage: 'linear-gradient(to bottom, #fff,  #e6e6e6);',
    backgroundRepeat: 'repeat-x',
    borderRadius: '0.25rem',
    fontSize: window.innerWidth > 540 ? '0.85rem' : '10px',
    alignItems: 'center',
  }),
}

function AnimatedMulti(props) {
    const {options, handleChosen, title} = props
    return (
        <div className="select-box">
            <span className="select-title">{title}</span>
        &nbsp;
        <Select 
            closeMenuOnSelect={false}
            components={animatedComponents}
            options={options}
            onChange={(e)=>handleChosen(e)}
            menuPortalTarget={document.body}
            styles={customStyles}
            placeholder={'Wszystkie'}
        />
        </div>
    )
}

function Filter({method, options, title}) {
    const handleChosen = (e) => {
        const {value} = e || ''
        method(value)
    }


  return (
    <AnimatedMulti 
        options={options}
        handleChosen={handleChosen}
        title={title}
    />
  )
}

export default Filter